/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Budget teams (< ${i?.threshold})`)
};

const es_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equipos de presupuesto (< ${i?.threshold})`)
};

const de_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Budget-Teams (< ${i?.threshold})`)
};

const nl_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Budget teams (< ${i?.threshold})`)
};

const fr_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Équipes budget (< ${i?.threshold})`)
};

const it_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Team budget (< ${i?.threshold})`)
};

const pt_br2_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Times econômicos (< ${i?.threshold})`)
};

const pt_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equipas económicas (< ${i?.threshold})`)
};

const ja_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`予算チーム (< ${i?.threshold})`)
};

const zh_f1_budget_tier_b_constructors_subtitle = /** @type {(inputs: { threshold: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预算型车队 (< ${i?.threshold})`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ threshold: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_tier_b_constructors_subtitle = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_tier_b_constructors_subtitle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_tier_b_constructors_subtitle", locale)
	if (locale === "en") return en_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "es") return es_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "de") return de_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "nl") return nl_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "fr") return fr_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "it") return it_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "pt") return pt_f1_budget_tier_b_constructors_subtitle(inputs)
	if (locale === "ja") return ja_f1_budget_tier_b_constructors_subtitle(inputs)
	return zh_f1_budget_tier_b_constructors_subtitle(inputs)
};